import { ReactNode } from "react";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { useCheckOverflow } from "../../hooks";
import ChevronLeftIcon from "../../img/icons/chevron-left.svg?react";
import ChevronRightIcon from "../../img/icons/chevron-right.svg?react";
import StatItem from "./StatItem";
import {
  chevronLeftStyles,
  chevronRightStyles,
  containerStyles,
  iconContainer,
  statListStyles,
} from "./statsList.css";

export type StatItemType = {
  title: ReactNode;
  value?: number | string;
  subValue?: string;
};

interface StatsListProps {
  stats: StatItemType[];
}

const StatsList = ({ stats }: StatsListProps) => {
  const { noStatsAvailable } = usePlosTranslations();
  const { containerRef, isOverflowing } = useCheckOverflow();

  const listVariant = isOverflowing ? "scroll" : "default";

  return (
    <div className={containerStyles}>
      {isOverflowing && (
        <div className={iconContainer}>
          <ChevronLeftIcon className={chevronLeftStyles} />
          <ChevronRightIcon className={chevronRightStyles} />
        </div>
      )}
      <ul className={statListStyles[listVariant]} ref={containerRef}>
        {stats.length !== 0 ? (
          stats.map(({ title, value, subValue }, idx) => (
            <StatItem
              key={idx}
              title={title}
              value={value}
              subValue={subValue}
            />
          ))
        ) : (
          <span>{noStatsAvailable}</span>
        )}
      </ul>
    </div>
  );
};

export default StatsList;
